import React from 'react';
import { SectionHeading } from '../product/SectionHeading';
import type { SolutionChallenge } from '../../types/solution';
export function ChallengeCards({
  items
}: {
  items: SolutionChallenge[];
}) {
  return <section className="w-full bg-white py-20" aria-labelledby="challenges-heading" data-id="element-1486" data-mp="1q8y19z0kb8pv">
      <div className="mx-auto max-w-shell px-6" data-id="element-1487" data-mp="1lb6ax9fkfuns">
        <SectionHeading id="challenges-heading" title="Sound familiar?" data-id="element-1488" data-mp="1lchfhbgu56fy" />
        <ul className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-3" data-id="element-1489" data-mp="2hzm4dglsqo66">
          {items.map(item => <li key={item.quote} className="flex h-full flex-col rounded-[14px] bg-canvas-sky p-7" data-id="element-1490" data-mp="2e0mz1uw5kpe7">
              <span className="display text-[40px] leading-none text-brand" aria-hidden="true" data-id="element-1491" data-mp="28ynx8pg2a0jd">
                “
              </span>
              <p className="mt-2 text-[20px] font-semibold leading-[1.35] tracking-[-0.02em] text-ink" data-id="element-1492" data-mp="243iaxpiqyjur">{item.quote}</p>
              <p className="mt-auto pt-5 text-[14.5px] leading-[1.55] text-ink-muted" data-id="element-1493" data-mp="sm8u7ar065x5">{item.detail}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}